import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
const MESSAGE_GROUP_HEADING_BASE_CSS = css `
  color: #aaa;
  font-size: 85%;
  padding-top: 3px;
`;
const LEFT_HEADING_CSS = MESSAGE_GROUP_HEADING_BASE_CSS;
const RIGHT_HEADING_CSS = css(MESSAGE_GROUP_HEADING_BASE_CSS, css `
    text-align: right;
  `);
function getMessageGroupHeading(messages, messageIndex, myPlayerId, conversationPlayer) {
    if (myPlayerId === undefined) {
        return;
    }
    const { fromPlayerId } = messages[messageIndex];
    if (fromPlayerId === undefined) {
        return;
    }
    if (messageIndex === 0 || messages[messageIndex - 1].fromPlayerId !== fromPlayerId) {
        const isMe = fromPlayerId === myPlayerId;
        return { heading: isMe ? 'Me' : conversationPlayer.name, isMe };
    }
}
export const DirectMessageGroupHeadingContainer = ({ messages, messageIndex, myPlayerId, conversationPlayer }) => {
    const messageGroupHeading = getMessageGroupHeading(messages, messageIndex, myPlayerId, conversationPlayer);
    if (!messageGroupHeading) {
        return null;
    }
    return _jsx("div", { css: messageGroupHeading.isMe ? RIGHT_HEADING_CSS : LEFT_HEADING_CSS, children: messageGroupHeading.heading });
};
